module.exports = "<div ui-grid=grid></div>";